module.exports = __webpack_public_path__ + "static/sport/title.7e7d888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/title.png
// module id = 1jRM
// module chunks = 0